/**
 * Mobile Navigation Module
 * Handles mobile navigation functionality
 */

class MobileNavigation {
    constructor() {
        this.init();
    }

    init() {
        console.log('inited');
        document.addEventListener("DOMContentLoaded", function() {
            const mobileOpenBtn = document.getElementById("mobile-open");
            const mobileCloseBtn = document.getElementById("mobile-close");
          
            if (mobileOpenBtn) {
              mobileOpenBtn.addEventListener("click", function() {
                console.log('open!');
                document.body.classList.add("mobile-menu-open");
              });
            }
          
            if (mobileCloseBtn) {
              mobileCloseBtn.addEventListener("click", function() {
                document.body.classList.remove("mobile-menu-open");
              });
            }
          });          
    }
}

// Initialize mobile navigation
new MobileNavigation(); 